module.exports = "/virtual-football-league/img/amblems/right/logos/Milan.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Milan.png
// module id = 2216
// module chunks = 4